import React from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { showFileManager, setLockBackground } from '@/store/actions'

import styles from './styles.scss'

import IconComponent from '@/components/commons/IconComponent'

const UploadImage = props => {
  const { icon, showFileManager, setLockBackground, onImageSended } = props

  return (
    <div className={styles['wrapper-upload-image']}>
      {
        icon ? (
          <button
            className={styles['wrapper-upload-image__icon']}
            onMouseDown={() => {
              showFileManager({
                isOpened: true,
                callback: onImageSended
              })
              setLockBackground({ isVisible: true })
            }}
          >
            <IconComponent icon="change-picture" />
          </button>
        ) : (
          <div
            className={styles['wrapper-upload-image__button']}
            onMouseDown={() => {
              showFileManager({
                isOpened: true,
                callback: onImageSended
              })
              setLockBackground({ isVisible: true })
            }}
          >
            <builderall-icon code='fc98'></builderall-icon>
            {/* <IconComponent icon="image" /> */}
            {/* <span>{ translation( 'image-select' ) }</span> */}
          </div>
        )
      }
    </div>
  )
}


UploadImage.propTypes = {
  icon: propTypes.bool,
  onImageSended: propTypes.func
}

UploadImage.defaultProps = {
  icon: false,
  onImageSended: () => { }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(
  mapStateToProps,
  { showFileManager, setLockBackground }
)(UploadImage)



// WEBPACK FOOTER //
// ./src/components/UploadImage/index.js